import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';

/**
 * Its own module, and deliberately free of runtime imports: the React Native contact CTA
 * shares these two, and pulling them from `utils.ts` would drag that file's web-only SVG
 * imports into the native type program, where `.svg` resolves to a different component type.
 */

/**
 * An unapproved service is announced as "Coming Soon" instead, so away never competes
 * with it. The service selector shows a badge; the booking CTA dims the service instead,
 * so both call this to agree on when a service counts as away.
 */
export const isServiceAway = (
  service?: Pick<EnhancedPersonSitterProfileService, 'isAway' | 'isApproved'>
): boolean => !!service?.isAway && !!service?.isApproved;

/**
 * The booking CTA dims an away service rather than badging it. `tertiary` is the lightest
 * neutral that still clears WCAG 2.2 AA against `background.primary`, at 5.64:1. The
 * dimming carries no information on its own, so every surface that applies it also names
 * the row "<service> (Away)" for assistive technology.
 */
export const AWAY_TEXT_COLOR = 'tertiary' as const;
